module.exports = __webpack_public_path__ + "static/media/result-3-zh-HK.25b152b8.png";